import { useEffect } from "react";
import { Alert, Button } from "@mui/material";
import { usePassPlanner } from "./PassPlannerContext";

export const PassLocationPrompt = () => {
  const { picking, cancelPicking } = usePassPlanner();
  useEffect(() => {
    if (!picking) return;
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") cancelPicking();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [picking, cancelPicking]);
  if (!picking) return null;
  return (
    <Alert
      severity="info"
      role="status"
      action={
        <Button color="inherit" size="small" onClick={cancelPicking}>
          Cancel
        </Button>
      }
      sx={{
        position: "absolute",
        top: 12,
        left: 12,
        right: 12,
        mx: "auto",
        maxWidth: 520,
        zIndex: 12,
      }}
    >
      Tap a location on the Earth to place your observing pin.
    </Alert>
  );
};
